<template>
  <div class="newBenchMark">
    <div class="top">
      <div class="left-box">
        <div class="top-title" @click="pushDo">Benchmark</div>
      </div>
      <div class="version-content" >
        <div class="version-bg">
          <div class="tool-box">
            <div class="tool-title-box">
              <Version
                class="version-w"
                :list="toolList"
                :versionIndex="0"
                :version="leftTool.tool"
                @selectIrqDo="selectIrqDo"
              >
              </Version>
            </div>
            <div class="tool-line">
              <img src="@/assets/line-icon.png" />
            </div>
            <div class="tool-title-box">
              <Version
                class="version-w"
                :list="leftVersionList"
                :versionIndex="1"
                :version="leftTool.release"
                @selectIrqDo="selectIrqDo"
              ></Version>
            </div>
            <div class="vs-box">
              <div class="vs-title" :style="{ color: vsStyle.color }">VS</div>
              <el-switch
                class="vs-switch"
                v-model="isSwitch"
                active-color="#0050B3"
                inactive-color="#E8E8E8"
                @change="switchChange"
              ></el-switch>
            </div>
            <!-- v-show="isSwitch" -->
            <div class="tool-title-box" :style="{ visibility: rightShow }">
              <Version
                class="version-w"
                :backgroundColor="versionBackColor"
                :list="toolList"
                :version="rightTool.tool"
                :versionIndex="2"
                @selectIrqDo="selectIrqDo"
              ></Version>
            </div>
            <div class="tool-line" :style="{ visibility: rightShow }">
              <img src="@/assets/line-icon.png" />
            </div>
            <div class="tool-title-box" :style="{ visibility: rightShow }">
              <Version
                class="version-w"
                :backgroundColor="versionBackColor"
                :list="rightVersionList"
                :version="rightTool.release"
                :versionIndex="3"
                @selectIrqDo="selectIrqDo"
              ></Version>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg">
      <el-table
        v-loading="loading"
        element-loading-text="Loading..."
        class="table"
        :data="tableData"
        ref="dragTable"
        :row-key="getRowKey"
        :row-class-name="tableRowClassName"
        show-summary
        :sum-text="getSum()"
        border
        fit
        :header-cell-style="{
          background: '#F6F6F6',
          borderLeft: '0.5px solid #999999',
          borderRight: '0.5px solid #999999',
          borderTop: '1px solid #999999',
          borderBottom: '1px solid #999999',
        }"
        :cell-style="{
          background: '#FFFFFF',
          borderBottom: '0.5px solid #707070',
          borderRight: '0.5px solid #999999',
          borderLeft: '0.5px solid #999999',
        }"
        :height="getHeight()"
      >
        <el-table-column
          fixed
          min-width="190"
          :width="flexTestCaseWidth(tableData)"
          align="center"
        >
          <template #header>
            <div class="header-case-title header-item">Test case</div>
          </template>
          <template #default="scope">
            <div class="table-case">
              <div
                class="case-dian"
                @mouseover="mouseDianOver(scope.row)"
                @mouseleave="mouseDianLeave(scope.row)"
              >
                <img
                  src="@/assets/dian-icon.png"
                  :style="{ visibility: scope.row.isShowDian }"
                />
              </div>
              <div class="case-no">{{ scope.$index + 1 }}</div>
              <div
                class="case-img"
                @mouseover="mouseover(scope.row)"
                @mouseleave="mouseleave(scope.row)"
              >
                <img
                  src="@/assets/pop-icon.png"
                  :style="{ visibility: scope.row.isOver }"
                  @click="popDilog(scope.row, scope.$index)"
                />
              </div>
              <div class="case-title">{{ scope.row?.testCase }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- flexColumnWidth  width="160"-->
        <el-table-column
          align="left"
          v-for="(title, index) in headerTitles"
          :key="index"
          min-width="100"
          :width="flexColumnWidth(tableData, sortHeaderTitles, index)"
        >
          <template #header>
            <div class="header-title header-item">{{ title }}</div>
          </template>
          <template #default="scope">
            <item
              :isCompare="isSwitch"
              :index="scope.$index"
              :headerTitle="sortHeaderTitles[index]"
              :model="scope.row[sortHeaderTitles[index]]"
            ></item>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CaseDetail
      :dialogVisible="dialogVisible"
      :isCompare="isSwitch"
      @closeDo="closeDo"
      @previousDo="previousDo"
      @nextDo="nextDo"
      :headers="headerTitles"
      :model="selectModel"
    ></CaseDetail>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import Item from "@/components/Item.vue";
import Version from "@/components/Version.vue";
import CaseDetail from "@/components/CaseDetail.vue";
import { getBenchMarks } from "@/request/api";

export default {
  data() {
    return {
      dialogVisible: false,
      selectModel: {},
      selectIndex: 0,
      tableData: [],
      sortTableData: [],
      allMarkList: [],
      headerTitles: [],
      sortHeaderTitles: [],

      isSwitch: false,
      vsStyle: {
        color: "#0050B3",
      },
      leftTool: {},
      rightTool: {},
      toolList: [],
      versionList: [],
      leftVersionList: [],
      rightVersionList: [],
      setingItemList: [],
      showImg: "hidden",
      rightShow: "hidden",
      contentMaxWidth: 1200,
      loading: false,
    };
  },
  mounted() {
    this.rowDrop();
    this.columnDrop();
  },
  methods: {
    getStrWidth(str) {
      let flexWidth = 0;
      for (const char of str) {
        if (char >= "A" && char <= "Z") {
          flexWidth += 10;
        } else if (char >= "a" && char <= "z") {
          flexWidth += 9;
        } else if (char >= "\u4e00" && char <= "\u9fa5") {
          // 如果是中文字符，为字符分配15个单位宽度
          flexWidth += 20;
        } else if (char == "(" || char == ")") {
          flexWidth += 9;
        } else if (char == "\u00A0" || char == "\u0020" || char == "\u3000") {
          //如果是空格
          flexWidth += 1;
        } else if (char >= 0 && char <= 9) {
          flexWidth += 10
        } else {
          // 其他种类字符，为字符分配8个单位宽度
          flexWidth += 11;
        }
      }
      return flexWidth;
    },
    //根据表头label设表格列宽度
    flexTestCaseWidth(tableData) {
      let maxWidth = 0;
      for (const item of tableData) {
        const str = item?.testCase;
        let flexWidth = this.getStrWidth(str);
        if (flexWidth < 80) {
          flexWidth = 180;
        }
        if (flexWidth >= maxWidth) {
          maxWidth = flexWidth;
        }
      }
      maxWidth += 135
      return maxWidth 
    },

    // 根据表格列内容里最长的一个设宽度
    flexColumnWidth(tableData, sortHeaderTitles, index) {
      let maxWidth = 130;
      const headerTitle = sortHeaderTitles[index];
      let flexWidth = this.getStrWidth(headerTitle);
      flexWidth += 10;
      for (const model of tableData) {
        const list = Object.keys(model);
        if (list.includes(headerTitle)) {
          const contentValue = model[headerTitle];
          let width1 = 0;
          let width2 = 0;
          if (contentValue?.num1) {
            width1 = this.getStrWidth(contentValue.num1)
            width1 += 10;
          }
          if (contentValue?.num2) {
            width2 = this.getStrWidth(contentValue.num2)
            width2 += 10;
          }
          if (this.isSwitch) {
            if (width1 != 0 || width2 != 0) {
              if (width1 == 0) {
                width1 = width2 
              } else if (width2 == 0) {
                width2 = width1 
              }
            }
          }
          maxWidth = (width1 + width2) > flexWidth ? (width1 + width2) : flexWidth;
        }
      }
      return maxWidth;
    },

    getHeight() {
      const h = `${document.documentElement.clientHeight}`;
      return h - 230;
    },
    pushDo() {
      this.$router.push({ name: "Home" });
    },
    getRowKey(row) {
      return row.testCase;
    },
    selectIrqDo(model) {
      console.log("model = ", model);
      const versionIndex = model.versionIndex;
      if (versionIndex == 0) {
        this.leftTool.tool = model.item.originTitle;
        this.getLeftVersionList();
        this.leftTool.release = this.leftVersionList[0].originTitle;
      } else if (versionIndex == 1) {
        this.leftTool.release = model.item.originTitle;
      } else if (versionIndex == 2) {
        this.rightTool.tool = model.item.originTitle;
        this.getRightVersionList();
        this.rightTool.release = this.rightVersionList[0].originTitle;
      } else if (versionIndex == 3) {
        this.rightTool.release = model.item.originTitle;
      }
      this.getSelectMarks();
    },
    getSum() {
      return this.tableData.length + "records";
    },
    getSelectMarks() {
      console.log("getSelectMarks....");
      this.loading = true;
      this.tableData = [];
      const leftDataList = [];
      const rightDataList = [];
      const allTestCaseList = [];
      for (const mark of this.allMarkList) {
        const resultsMap = mark.resultsMap;
        if (
          mark.tool == this.leftTool.tool &&
          mark.release == this.leftTool.release
        ) {
          const item = {
            isOver: "hidden",
            isShowDian: "hidden",
            testCase: mark.testcase,
            tool: {
              leftTool: this.leftTool.tool,
              rightTool: this.rightTool.tool,
            },
            release: {
              leftRelease: this.leftTool.release,
              rightRelease: this.rightTool.release,
            },
          };
          for (const map of resultsMap) {
            const key = map[0];
            item[`${key}`] = {
              num1: map[1],
              num2: "",
            };
          }
          this.tableData.push(item);
          leftDataList.push(item);
          allTestCaseList.push(mark.testcase);
        }
        if (this.isSwitch) {
          if (
            mark.tool == this.rightTool.tool &&
            mark.release == this.rightTool.release
          ) {
            const item = {
              isOver: "hidden",
              isShowDian: "hidden",
              testCase: mark.testcase,
              tool: {
                leftTool: this.leftTool.tool,
                rightTool: this.rightTool.tool,
              },
              release: {
                leftRelease: this.leftTool.release,
                rightRelease: this.rightTool.release,
              },
            };

            for (const map of resultsMap) {
              const key = map[0];
              item[`${key}`] = {
                num1: "",
                num2: map[1],
              };
            }
            // this.tableData.push(item);
            rightDataList.push(item);
            allTestCaseList.push(mark.testcase);
          }
        }
      }

      console.log(
        "leftDataList = ",
        leftDataList,
        "rightDataList = ",
        rightDataList
      );

      if (this.isSwitch) {
        const leftHeaders = Object.keys(leftDataList[0]).slice(5);
        const rightHeaders = Object.keys(rightDataList[0]).slice(5);

        const newHeaders = leftHeaders.concat(rightHeaders);
        const allHeaders = [...new Set(newHeaders)];
        const newAllList = [];

        const allDataList = leftDataList.concat(rightDataList);
        const setAllTestCaseList = [...new Set(allTestCaseList)];
        for (const testCaseStr of setAllTestCaseList) {
          const arr = allDataList.filter((dataM) => {
            return dataM.testCase == testCaseStr;
          });
          if (arr.length >= 2) {
            const m1 = arr[0];
            const m2 = arr[1];
            for (const headerStr of allHeaders) {
              m1[`${headerStr}`] = {
                num1: m1[headerStr]?.num1,
                num2: m2[headerStr]?.num2,
              };
            }
            newAllList.push(m1);
          } else {
            newAllList.push(arr[0]);
          }
        }
        this.tableData = newAllList;
        this.headerTitles = [...allHeaders];
        this.sortHeaderTitles = [...allHeaders];
      } else {
        const headers = Object.keys(this.tableData[0]);
        const ll = headers.slice(5);
        this.headerTitles = [...ll];
        this.sortHeaderTitles = [...ll];
      }

      this.selectModel = this.tableData[0];
      console.log("this.headerTitles = ", this.headerTitles);
      this.tableLayout()
      this.loading = false;
    },
    getLeftVersionList() {
      this.leftVersionList = [];
      for (const version of this.versionList) {
        if (version.tool == this.leftTool.tool) {
          this.leftVersionList.push(version);
        }
      }
    },
    getRightVersionList() {
      this.rightVersionList = [];
      for (const version of this.versionList) {
        if (version.tool == this.rightTool.tool) {
          this.rightVersionList.push(version);
        }
      }
    },
    setingSwitchChange() {
      console.log("setting do ....");
    },
    switchChange() {
      this.vsStyle.color = this.isSwitch ? "#0050B3" : "#B8B8B8";
      this.rightShow = this.isSwitch ? "visible" : "hidden";
      this.getSelectMarks();
    },
    // 设置表格row的class
    tableRowClassName({ row }) {
      if (row.disabled) {
        return "disabled";
      }
      return "";
    },
    closeDo() {
      this.dialogVisible = false;
    },
    previousDo() {
      console.log("previous do ....");
      if (this.selectIndex <= 0) {
        this.$message.warning("已经到顶了");
        return;
      }
      this.selectIndex--;
      this.selectModel = this.tableData[this.selectIndex];
    },
    nextDo() {
      console.log("next do ....");
      if (this.selectIndex >= this.tableData.length - 1) {
        this.$message.warning("已经到底了");
        return;
      }
      this.selectIndex++;
      this.selectModel = this.tableData[this.selectIndex];
    },
    //行拖拽
    rowDrop() {
      this.$nextTick(() => {
        setTimeout(() => {
          const tbody = document.querySelector(".el-table__fixed tbody");
          Sortable.create(tbody, {
            animation: 150,
            delay: 0,
            disabled: false, // 拖拽不可用? false 启用（刚刚渲染表格的时候起作用，后面不起作用）
            handle: ".case-dian", //指定拖拽目标，点击此目标才可拖拽元素(此例中设置操作按钮拖拽)
            filter: ".disabled", //指定不可拖动的类名（el-table中可通过row-class-name设置行的class）
            dragClass: "dragClass", // 正在被拖拽中的css类名
            onEnd: (evt) => {
              console.log(evt.newIndex, evt.oldIndex);
              const currRow = this.tableData.splice(evt.oldIndex, 1)[0];
              this.tableData.splice(evt.newIndex, 0, currRow);
            },
          });
        });
      });
    },
    //列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          this.$nextTick(() => {
            const sortNewIndex = evt.newIndex - 1;
            const sortOldIndex = evt.oldIndex - 1;
            console.log(sortNewIndex, sortOldIndex);
            const currRow = this.sortHeaderTitles.splice(sortOldIndex, 1)[0];
            this.sortHeaderTitles.splice(sortNewIndex, 0, currRow);
          });
        },
      });
    },
    mouseDianOver(item) {
      console.log("mouseDian");
      item.isShowDian = "visible";
    },
    mouseDianLeave(item) {
      console.log("mouseDianLeave");
      item.isShowDian = "hidden";
    },
    mouseover(item) {
      this.showImg = "visible";
      item.isOver = "visible";
    },
    mouseleave(item) {
      this.showImg = "hidden";
      item.isOver = "hidden";
    },
    popDilog(item, index) {
      this.dialogVisible = true;
      this.selectModel = item;
      this.selectIndex = index;
      console.log(
        "this.selectModel  = ",
        this.selectModel,
        "selectIndex = ",
        this.selectIndex
      );
    },
    //错位 
    tableLayout() {
      this.$nextTick( ()=> {
        this.$refs.dragTable.doLayout()
      })
    }
  },
  async created() {
    this.loading = true
    console.log("created....");
    const allMarks = await getBenchMarks({});
    this.allMarkList = allMarks;
    console.log("allMarks = ", allMarks);

    const toolOriginList = [];
    const versionOriginList = [];
    for (const item of allMarks) {
      if (item.tool && !toolOriginList.includes(item.tool)) {
        var title1 = item.tool;
        if (item.tool.includes("/")) {
          title1 = item.tool.split("/").pop();
        }

        const toolItem = {
          originTitle: item.tool,
          title: title1,
        };
        toolOriginList.push(item.tool);
        this.toolList.push(toolItem);
      }
      if (item.release && !versionOriginList.includes(item.release)) {
        var title2 = item.release;
        if (item.release.includes("/")) {
          const lastTitle = item.release.split("/").pop();
          if (lastTitle.includes(":")) {
            title2 = lastTitle.split(":").pop();
          }
        }

        const versionItem = {
          originTitle: item.release,
          title: title2,
          tool: item.tool,
        };
        versionOriginList.push(item.release);
        this.versionList.push(versionItem);
      }
    }
    const model = {
      tool: this.toolList[0].originTitle,
      release: this.versionList[0].originTitle,
    };
    this.leftTool = JSON.parse(JSON.stringify(model));
    this.rightTool = JSON.parse(JSON.stringify(model));

    for (const mark of allMarks) {
      if (mark.tool == model.tool && mark.release == model.release) {
        const resultsMap = mark.resultsMap;
        const item = {
          isOver: "hidden",
          isShowDian: "hidden",
          testCase: mark.testcase,
          tool: {
            leftTool: mark.tool,
          },
          release: {
            leftRelease: mark.release,
          },
        };
        for (const map of resultsMap) {
          const key = map[0];
          item[`${key}`] = {
            num1: map[1],
          };
        }
        this.tableData.push(item);
      }
    }

    this.getLeftVersionList();
    this.getRightVersionList();

    console.log("tableData = ", this.tableData);
    const headers = Object.keys(this.tableData[0]);
    const ll = headers.slice(5);
    this.headerTitles = [...ll];
    this.sortHeaderTitles = [...ll];
    this.selectModel = this.tableData[0];
    this.tableLayout()
    this.loading = false;
  },
  updated() {
    console.log("updated....");
    // this.rowDrop()
  },
  components: {
    Item,
    CaseDetail,
    Version,
  },
};
</script>

<style lang='less' scoped>
.top {
  height: 180px;
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #0050b3;
  // position: relative;
  .left-box {
    background-color: #0050b3;
    margin-left: 60px;
    .top-title {
      color: #fff;
      font-weight: bold;
      font-size: 38px;
      margin-top: 60px;
      cursor: pointer;
    }
  }

  .version-content {
    display: flex;
    flex-direction: row;
    width: calc(100% - 256px);
    background-color: #0050b3;
    margin-top: 20px;
    padding: 0px 30px 0px 60px;

    .version-bg {
      display: flex;
      flex-direction: row;
      align-items: center;
      // width: 100%;
    }

    .tool-box {
      display: flex;
      flex-direction: row;
      background-color: #fff;
      // width: 100%;
      padding: 20px 20px 20px 0px;
      border-radius: 6px;
      align-items: center;
      margin-top: 26px;

      .tool-title-box {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        // width: 400px;
        .version-w {
          margin-top: 8px;
          // width: 100%;
          background-color: palegoldenrod;
        }
      }

      .tool-line {
        margin-left: 30px;
        margin-top: 10px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background-color: red;
        img {
          object-fit: contain;
        }
      }

      .vs-box {
        width: 50px;
        margin-left: 30px;

        .vs-title {
          color: #0050b3;
          font-size: 20px;
          font-weight: 900;
        }

        .vs-switch {
          width: 40px;
          height: 18px;
        }
      }
    }
  }
}

.bg {
  padding: 30px 20px 0px 20px;
}

.table {
  // border: 2px solid #999999;
  // border-radius: 5px;
}

.header-item {
  display: flex;
  height: 100%;
  width: 100%;
  color: #000000;
  font-size: 13px;
  font-weight: 500;
  padding-top: 5px;
  padding-bottom: 5px;
}

.header-title {
  padding-left: 10px;
}
.header-case-title {
  padding-left: 130px;
}
.table-case {
  display: flex;
  flex-direction: row;
  align-items: center;

  .case-dian {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 5px;
    width: 30px;
    height: 50px;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  .case-no {
    color: #999999;
    font-size: 18px;
    margin-left: 10px;
    width: 30px;
  }
  .case-img {
    height: 35px;
    width: 40px;
    margin-left: 8px;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  .case-title {
    margin-left: 10px;
    font-size: 14px;
    color: #565656;
  }
}

:deep(.el-table .cell) {
  padding: 0 !important;
}

:deep(.el-table td) {
  padding: 1px 0 !important;
}

:deep(.el-table th) {
  user-select: initial !important;
}
</style>
